var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { Field } from 'react-final-form';
import { isEqual } from 'lodash';
import FFFieldListnerWrapper from '../inputs/FFFieldListnerWrapper';
import MultiSelectDropDown from '../inputs/MultiSelectDropDown';
var MultiSelectRenderer = function (_a) {
    var _b, _c, _d;
    var fieldRenderProps = _a.fieldRenderProps, componentProps = _a.componentProps;
    var _e = __read(useState([]), 2), updatedValues = _e[0], setUpdatedValues = _e[1];
    var input = fieldRenderProps.input, meta = fieldRenderProps.meta;
    useEffect(function () {
        if (input.value === '' || typeof input.value === 'undefined') {
            setUpdatedValues([]);
            return;
        }
        if (!isEqual(input.value, updatedValues) && typeof input.value !== 'string') {
            setUpdatedValues(input.value);
        }
    }, [input.value]);
    return (React.createElement(MultiSelectDropDown, __assign({ error: (_b = Boolean(meta.touched && meta.error)) !== null && _b !== void 0 ? _b : componentProps === null || componentProps === void 0 ? void 0 : componentProps.error, helperText: (_c = (meta.touched ? meta.error : undefined)) !== null && _c !== void 0 ? _c : componentProps === null || componentProps === void 0 ? void 0 : componentProps.helperText }, componentProps, { options: (_d = componentProps === null || componentProps === void 0 ? void 0 : componentProps.options) !== null && _d !== void 0 ? _d : [], onChange: function (event, value, reason) {
            var _a;
            input.onChange(value);
            (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.onChange) === null || _a === void 0 ? void 0 : _a.call(componentProps, event, value, reason);
        }, onBlur: function (event) {
            var _a;
            input.onBlur(event);
            (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.onBlur) === null || _a === void 0 ? void 0 : _a.call(componentProps, event);
        }, onFocus: function (event) {
            var _a;
            input.onFocus(event);
            (_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.onFocus) === null || _a === void 0 ? void 0 : _a.call(componentProps, event);
        }, value: updatedValues })));
};
var FFMultiselect = function (_a) {
    var fieldProps = _a.fieldProps, componentProps = _a.componentProps, onFieldBlur = _a.onFieldBlur, onFieldChange = _a.onFieldChange, onFieldFoucus = _a.onFieldFoucus;
    return (React.createElement(FFFieldListnerWrapper, { name: fieldProps.name, onFieldBlur: onFieldBlur, onFieldChange: onFieldChange, onFieldFoucus: onFieldFoucus },
        React.createElement(Field, __assign({}, fieldProps, { render: function (renderProps) { return React.createElement(MultiSelectRenderer, { fieldRenderProps: renderProps, componentProps: componentProps }); } }))));
};
export default FFMultiselect;
//# sourceMappingURL=FFMultiselect.js.map